module.exports = __webpack_public_path__ + "8598360fc7b876068ff6dc8c2fb1b461.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room8/audio3/08_3MCA Upside Down Table.mp3
// module id = 792
// module chunks = 0